import React, { useState } from "react";

const Suggestion = ({ open, onClose, responseFromResult }) => {
  const [text, setText] = useState("");

  if (!open) return null;

  const handleDownload = () => {
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "suggestion.txt";
    a.click();

    URL.revokeObjectURL(url);
  };

  return (
    <div
  className="popup-overlay"
  style={{
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
    backdropFilter: "blur(3px)",
  }}
>
  <div
    className="popup"
    style={{
      background: "linear-gradient(135deg, #ffffff 0%, #f7faff 100%)",
      borderRadius: "16px",
      padding: "25px 30px",
      width: "850px",
      minHeight: "450px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
      animation: "fadeIn 0.3s ease",
      color: "#222",
      overflowY: "auto",
    }}
  >
    <h2
      style={{
        marginBottom: "16px",
        textAlign: "center",
        fontSize: "1.5rem",
        fontWeight: "600",
        color: "#2b6cb0",
      }}
    >
      Suggestions
    </h2>

    {/* Strengths Section */}
    {responseFromResult?.strengths_weaknesses && (
      <div style={{ marginBottom: "20px" }}>
        {/* Parse text into structured sections */}
        {(() => {
          const text = responseFromResult.strengths_weaknesses;
          const strengthsMatch = text.match(/Strengths:(.*?)(?=Weaknesses:|$)/s);
          const weaknessesMatch = text.match(/Weaknesses:(.*)/s);

          const strengths =
            strengthsMatch?.[1]
              ?.split("-")
              ?.filter((s) => s.trim())
              ?.map((s) => s.trim()) || [];
          const weaknesses =
            weaknessesMatch?.[1]
              ?.split("-")
              ?.filter((s) => s.trim())
              ?.map((s) => s.trim()) || [];

          return (
            <div>
              {/* Strengths */}
              <div
                style={{
                  background: "#e6f9ed",
                  borderRadius: "10px",
                  padding: "15px 20px",
                  marginBottom: "15px",
                  borderLeft: "5px solid #28a745",
                }}
              >
                <h3
                  style={{
                    color: "#218838",
                    fontWeight: "600",
                    marginBottom: "8px",
                  }}
                >
                  Strengths 💪
                </h3>
                <ul style={{ paddingLeft: "20px", margin: 0, lineHeight: "1.6" }}>
                  {strengths.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>

              {/* Weaknesses */}
              <div
                style={{
                  background: "#fff4f4",
                  borderRadius: "10px",
                  padding: "15px 20px",
                  borderLeft: "5px solid #dc3545",
                }}
              >
                <h3
                  style={{
                    color: "#c82333",
                    fontWeight: "600",
                    marginBottom: "8px",
                  }}
                >
                  Weaknesses ⚠️
                </h3>
                <ul style={{ paddingLeft: "20px", margin: 0, lineHeight: "1.6" }}>
                  {weaknesses.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })()}
      </div>
    )}

    {/* Buttons */}
    <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        gap: "12px",
        marginTop: "25px",
      }}
    >
      <button
        onClick={onClose}
        style={{
          background: "linear-gradient(135deg, #ff5f6d, #ffc371)",
          border: "none",
          padding: "10px 18px",
          borderRadius: "8px",
          cursor: "pointer",
          color: "#fff",
          fontWeight: "500",
          transition: "transform 0.2s",
        }}
        onMouseOver={(e) => (e.target.style.transform = "scale(1.05)")}
        onMouseOut={(e) => (e.target.style.transform = "scale(1)")}
      >
        Close
      </button>
    </div>
  </div>
</div>

  );
};

export default Suggestion;
